import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, SweepstakeDetails, DrawingGroupTable } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';

const SecondChancePromotionPage = ({ user, config, sweep, cmsSourceFirebase, actions, match, loading }) => {
    const [promotionName, setPromotionName] = useState('Promotion Details');

    const telescriptSweepstakeDetails = getCMSObject('data.components.teleScripts.sweepstakeDetails.jsonBlock');
    const telescriptDrawingGroupTable = getCMSObject('data.components.teleScripts.drawingGroupTable.jsonBlock');
    const winnerAutoCertified = config?.web?.features?.winnerAutoCertified;

    const DrawingGroupTableWrapper = ({ drawingGroup, loggedIn }) => {
        /*
            When the jurisdiction is unable to legally disclose the winners, an information modal should be displayed at the end of the drawing. 
            Since no winning file will be uploaded to the system for the drawing, we need to automatically certify the drawings. Otherwise,
            the winner link for the modal will not be displayed at all.
        */
        if (winnerAutoCertified) {
            const todayTimestamp = new Date().getTime();
            const updatedDrawingGroup = {
                ...drawingGroup,
                drawings: drawingGroup.drawings.map((item) => (item.quantum_end < todayTimestamp ? { ...item, certified: true } : item)),
            };

            return (
                <DrawingGroupTable
                    drawingGroup={updatedDrawingGroup}
                    loggedIn={loggedIn}
                    telescript={telescriptDrawingGroupTable}
                    WinnerLink={WinnerLinkWrapper}
                />
            );
        }

        return <DrawingGroupTable drawingGroup={drawingGroup} loggedIn={loggedIn} telescript={telescriptDrawingGroupTable} WinnerLink={WinnerLinkWrapper} />;
    };

    return (
        <Layout
            {...{
                user,
                sweep,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName ?? '',
                    },
                ],
            }}>
            <SweepstakeDetails
                {...{ user, sweep: sweep.sweepDetails, actions, loading }}
                telescript={telescriptSweepstakeDetails}
                DrawingGroupTable={DrawingGroupTableWrapper}
                setPageTitle={setPromotionName}
            />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondChancePromotionPage);
